import React, { useContext } from 'react';
import CollectionItem from './CollectionItems';
import ApparelContext from '../../context/apparel/apparelContext';
const Collections = () => {
  const apparelContext = useContext(ApparelContext);

  const { collections } = apparelContext;

  return (
    <div className='collections_items'>
      {collections.map((collection) => (
        <CollectionItem key={collection.id} collection={collection} />
      ))}
    </div>
  );
};

export default Collections;
